import React from 'react'
import {motion} from 'framer-motion'
import {AppWrap, MotionWrap} from '../../wrapper'
import stacksData from './stacksData';
import './Stacks.scss'

const Stacks = () => {
  return (
    <div className='app__stacks-wrapper-upper'>
      <h2 className='head-text'>
        <span>Scoolj Lab</span> Technology <span>Stack</span>
      </h2>
      <div className='app__stacks-wrapper'>
      <div className='app__stacks-intro'>
        <motion.p
          whileInView={{opacity: [0, 1]}}
          transition={{duration: 0.6}}
          className='p-text app__stacks-description'
        >
          Our technology subsidiary, <span className='bold-text'>Scoolj Lab</span>, leverages cutting-edge 
          technologies to build scalable, efficient, and user-friendly digital solutions that solve real business problems.
        </motion.p>
      </div>

      <div className='app__stacks-container'>
        <motion.div className='app__stacks-list'>
          {stacksData.map((stack, index) => (
            <motion.div
              whileInView={{opacity: [0, 1], y: [50, 0]}}
              transition={{duration: 0.5, delay: index * 0.05}}
              whileHover={{scale: 1.05, y: -10}}
              className='app__stacks-item app__flex'
              key={index}
            >
              <div className='app__stacks-item-icon app__flex'>
                <img src={stack.imgUrl} alt={stack.title} />
              </div>
              <p className='p-text'>{stack.title}</p>
            </motion.div>
          ))}
        </motion.div>
        
        <motion.div
          whileInView={{opacity: [0, 1]}}
          transition={{duration: 0.7, delay: 0.5}}
          className='app__stacks-cta'
        >
          <h3 className='head-text-small'>Ready to Build Something Amazing?</h3>
          <p className='p-text'>Let Scoolj Lab bring your digital vision to life with our expertise and proven technology stack.</p>
          <button className='app__stacks-cta-btn'>
            <span>Start Your Project</span>
          </button>
        </motion.div>
      </div>
      </div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(Stacks, 'app__stacks'),
  'stacks',
  'app__whitebg'
)